export default function every(values, test) {
    if (typeof test !== "function")
        throw new TypeError("test is not a function");
    var index = -1;
    for (var _i = 0, values_1 = values; _i < values_1.length; _i++) {
        var value = values_1[_i];
        if (!test(value, ++index, values)) {
            return false;
        }
    }
    return true;
}
